import React from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import ProgressBar, { IProgressBarProps } from '~/components/atoms/ProgressBar';

import styles from './RatingProgressBar.module.scss';

const digitsCount = (value: number) => {
  return 1 + Math.floor(Math.log10(Math.max(1, value)));
};

const RatingProgressBar: React.FC<
  Omit<IProgressBarProps, 'isAnimated'> & { isUpcoming: boolean }
> = ({ target, targetMax, value = 0, isUpcoming }) => {
  return (
    <div className={styles.container}>
      <p>{I18n.t('collections_rating')}</p>
      <span className={styles.barContainer}>
        <ProgressBar
          value={value}
          targetMax={targetMax}
          target={target}
          isAnimated
        />
        <div
          className={classNames(styles.value, {
            [styles.exceeded]: value > target,
            [styles.upcoming]: isUpcoming,
          })}
          style={{
            // 2 times the amount of digits in target and an additional character for the slash
            width: `${digitsCount(target) * 2 + 1}ch`,
          }}
        >{`${value}/${target}`}</div>
      </span>
    </div>
  );
};

export default React.memo(RatingProgressBar);
